module.exports = __webpack_public_path__ + "img/mind-logo.c25a13cb.svg";